import { TableResultsFilterDataType } from "../ScenarioResults/types";

function getUnitsToDisplay(units: TableResultsFilterDataType) {
  return units === TableResultsFilterDataType.ABSOLUTE
    ? "dataVisualisationTabSection.timeEvolution.units.absoluteDisplayUnits"
    : "dataVisualisationTabSection.timeEvolution.units.perLitreDisplayUnits";
}

export default getUnitsToDisplay;
